import { Pipe, PipeTransform } from '@angular/core';

const suffixes = ['K', 'M', 'B', 'T'];

@Pipe({
  name: 'formatCount',
  pure: true
})
export class FormatCountPipe implements PipeTransform {
  transform(value: number): string {
    if (isNaN(value) || value === Infinity || value === -Infinity) {
      return 'NaN';
    }

    if (value <= 99) {
      return `${value}`;
    }

    if (value >= 100 && value <= 999) {
      return '99+';
    }

    let magnitude = 0;
    let num = value;

    while (num >= 1000 && magnitude < suffixes.length) {
      num /= 1000;
      magnitude++;
    }

    const rounded = Number.isInteger(num) ? num : parseFloat(num.toFixed(1));

    return `${rounded}${suffixes[magnitude - 1]}`;
  }
}
